/* Copyright 2023 (Unpublished) Verto Inc. */

// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { LoginComponent } from '@root/root-components/login/login.component';
import { OAuthLoginComponent } from './root-components/oauth-login/oauth-login.component';
import { OAuthRedirectComponent } from './root-components/oauth-redirect/oauth-redirect.component';
import { PacksComponent } from './packs/packs.component';

// Services
import { CurrentUserGuard } from './services/root-services/current-user.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    title: 'Login',
  },
  {
    path: 'executions',
    loadChildren: () =>
      import('./logs/executions.module').then(
        (module) => module.ExecutionsModule
      ),
    canActivate: [CurrentUserGuard],
    title: 'Executions',
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('./campaigns/campaigns.module').then(
        (module) => module.CampaignsModule
      ),
    canActivate: [CurrentUserGuard],
    title: 'Campaigns',
  },
  {
    path: 'templates',
    loadChildren: () =>
      import('./templates/templates.module').then(
        (module) => module.TemplatesModule
      ),
    canActivate: [CurrentUserGuard],
    title: 'Templates',
  },
  {
    path: 'workflows',
    loadChildren: () =>
      import('./workflows/workflows.modules').then(
        (module) => module.WorkflowsModule
      ),
    canActivate: [CurrentUserGuard],
    title: 'Workflows',
  },
  {
    path: 'visualizer',
    loadChildren: () =>
      import('./visualizer/visualizer.module').then(
        (module) => module.VisualizerModule
      ),
    canActivate: [CurrentUserGuard],
    title: 'Visualizer',
  },
  {
    path: 'packs',
    component: PacksComponent,
    canActivate: [CurrentUserGuard],
    data: {
      breadcrumb: 'Packs',
    },
    title: 'Packs',
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((module) => module.AdminModule),
    canActivate: [CurrentUserGuard],
    title: 'Admin',
  },
  {
    path: 'redirect',
    component: OAuthRedirectComponent,
  },
  {
    path: 'oauth-login',
    component: OAuthLoginComponent,
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
